import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import {
  MasterButton,
  InputOptionMaster,
  InputTextMaster,
  InputReactDatepicker,
  ModalExportList,
} from "App/Component/ui";
import { BASE_URL_4, TYPE_INSTANCE4 } from "App/constants";
import { useInitialMasterSupplier, useSelectOption } from "App/hooks";
import { getByFilterExport, RESET_STATE_FORM_FILTER } from "./helpers";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";

export default function FormFilterDaftarPO({
  formFilter,
  setFormFilter,
  setNewData,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [showModalExportList, setShowModalExportList] = useState(false);
  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewData();
  };

  const gudangUtama = useSelectOption(
    true,
    "/wmsMasterAsset/gudang/gudang_central",
    TYPE_INSTANCE4
  );

  const supplier = useInitialMasterSupplier(
    true,
    "/wmsMasterAsset/master/list-supplier"
  );

  const handleExport = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const res = await getByFilterExport(formFilter);
      if (res.state) {
        defaultToastSuccess(
          "Berhasil, mohon menunggu data sedang dieksport..."
        );
      } else {
        defaultToastError(res.message);
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      defaultToastError(error?.response?.data?.message);
    }
  };

  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={3}>
          <Grid item sm={12}>
            <Grid container spacing={3}>
              <Grid item sm={6}>
                <InputOptionMaster
                  name="gudang_id"
                  label="GUDANG UTAMA FIXED ASSET"
                  id="gudang_id"
                  withSearch={true}
                  data={gudangUtama}
                  value={formFilter.gudang_id}
                  labelValue={formFilter.gudang}
                  onChange={(e) => {
                    if (isNull(e)) {
                      setFormFilter({
                        ...formFilter,
                        gudang_id: "",
                        gudang: "Pilih Gudang",
                      });
                    } else {
                      setFormFilter({
                        ...formFilter,
                        gudang_id: e?.value,
                        gudang: e?.label,
                      });
                    }
                  }}
                />
              </Grid>

              <Grid item sm={6}>
                <InputOptionMaster
                  name="supplier_id"
                  label="SUPPLIER"
                  id="supplier_id"
                  withSearch={true}
                  data={supplier}
                  value={formFilter.supplier_id}
                  labelValue={formFilter.supplier}
                  onChange={(e) => {
                    if (isNull(e)) {
                      setFormFilter({
                        ...formFilter,
                        supplier_id: "",
                        supplier: "Pilih Supplier",
                      });
                    } else {
                      setFormFilter({
                        ...formFilter,
                        supplier_id: e?.value,
                        supplier: e?.label,
                      });
                    }
                  }}
                />
              </Grid>

              <Grid item sm={3}>
                <InputTextMaster
                  name="id"
                  type="number"
                  label="ID PEMBELIAN"
                  id="id"
                  value={formFilter.id}
                  onChange={handleChange("id")}
                  placeholder="ID Pembelian"
                />
              </Grid>

              <Grid item sm={3}>
                <InputTextMaster
                  name="no_faktur"
                  label="NOMOR FAKTUR"
                  id="no_faktur"
                  value={formFilter.no_faktur}
                  onChange={handleChange("no_faktur")}
                  placeholder="Nomor Faktur"
                />
              </Grid>

              <Grid item xs={6}>
                <InputOptionMaster
                  name="kategory_tanggal"
                  label="KATEGORI TANGGAL PENCARIAN"
                  id="kategory_tanggal"
                  value={formFilter.kategory_tanggal}
                  needParse={false}
                  onChange={handleChange("kategory_tanggal")}
                  data={[
                    {
                      value: "tanggal pembelian",
                      label: "Tanggal Pembelian",
                    },
                    {
                      value: "faktur",
                      label: "Faktur",
                    },
                    {
                      value: "jatuh tempo",
                      label: "Jatuh Tempo",
                    },
                    {
                      value: "tagih",
                      label: "Tagih",
                    },
                  ]}
                />
              </Grid>

              <Grid item sm={3}>
                <InputTextMaster
                  name="po"
                  label="NOMOR PO"
                  id="po"
                  value={formFilter.no_po}
                  onChange={handleChange("no_po")}
                  placeholder="Nomor PO"
                />
              </Grid>

              <Grid item xs={3}>
                <InputOptionMaster
                  name="is_PO"
                  label="KATEGORI PEMBELIAN"
                  id="is_PO"
                  value={formFilter.is_PO}
                  onChange={handleChange("is_PO")}
                  data={[
                    {
                      value: "",
                      label: "Semua",
                    },
                    {
                      value: 1,
                      label: "Dengan PO",
                    },
                    {
                      value: 0,
                      label: "Tanpa PO",
                    },
                    {
                      value: 2,
                      label: "Lunas",
                    },
                    {
                      value: 3,
                      label: "Tidak lunas",
                    },
                  ]}
                />
              </Grid>

              <Grid item sm={3}>
                {/* <InputTextMaster
                  name='tanggal_awal'
                  label='TANGGAL AWAL'
                  id='tanggal_awal'
                  type='date'
                  value={formFilter.tanggal_awal}
                  onChange={handleChange("tanggal_awal")}
                  placeholder='Tanggal Awal'
                /> */}

                <InputReactDatepicker
                  selected={formFilter.tanggal_awal}
                  label="TANGGAL AWAL"
                  handleChangeToday={(e) =>
                    setFormFilter({
                      ...formFilter,
                      tanggal_awal: e,
                    })
                  }
                  onChange={(e) =>
                    setFormFilter({
                      ...formFilter,
                      tanggal_awal: e,
                    })
                  }
                />
              </Grid>
              <Grid item sm={3}>
                {/* <InputTextMaster
                  name='tanggal_akhir'
                  label='TANGGAL AKHIR'
                  id='tanggal_akhir'
                  type='date'
                  value={formFilter.tanggal_akhir}
                  onChange={handleChange("tanggal_akhir")}
                  placeholder='Tanggal Akhir'
                /> */}

                <InputReactDatepicker
                  selected={formFilter.tanggal_akhir}
                  label="TANGGAL AKHIR"
                  handleChangeToday={(e) =>
                    setFormFilter({
                      ...formFilter,
                      tanggal_akhir: e,
                    })
                  }
                  onChange={(e) =>
                    setFormFilter({
                      ...formFilter,
                      tanggal_akhir: e,
                    })
                  }
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <MasterButton
            name={"RESET"}
            outline={true}
            color={"danger"}
            type={"button"}
            size={"md"}
            onClick={() => setFormFilter(RESET_STATE_FORM_FILTER)}
          />
          <div style={{ display: "flex", gap: 16 }}>
            <MasterButton
              type={"button"}
              color="primary-cyan"
              name={"Export List"}
              size="md"
              onClick={() => setShowModalExportList(!showModalExportList)}
            />

            <MasterButton
              type={"button"}
              color="warning"
              name={isLoading ? "Loading..." : "EXPORT"}
              disabled={isLoading}
              size="md"
              onClick={handleExport}
            />
            <MasterButton
              name={"CARI"}
              outline={true}
              color={"green"}
              type={"submit"}
              size={"md"}
            />
          </div>
        </Grid>
        <br />
      </form>
      {showModalExportList && (
        <ModalExportList
          title={"Export Transfer Fixed Asset"}
          showModal={() => setShowModalExportList(false)}
          type="PembelianAsset"
          service={BASE_URL_4}
        />
      )}
    </>
  );
}
